import { z } from "zod/v4-mini";

import { TandemEventDefinition } from "../TandemTypes";

export type CorruptionPayload = {};

export type CorruptionEvent = {};

const corruptionSchema = z.object({});

export const LID_DATA_LOG_CORRUPTION = {
  value: 0x3c,
  name: "Data Log Corruption Event",
  format: "................",
  fields: [],
  postprocess: () => ({}),
  schema: corruptionSchema,
} as const satisfies TandemEventDefinition<CorruptionPayload, CorruptionEvent>;
